import { DeepPartialSkipArrayKey } from 'react-hook-form'
import { FormValues } from '@typesApp/InsuranceForm'
import { ProviderType } from '@typesApp/Insurer'
import { logger } from '@utils/logger'

const KEY_INSURANCE_FORM_STATE = 'direct-billing.insurance-form'

type FormState = {
  formFields: FormValues
  formIndex?: number
  providerType?: ProviderType
}

type FormStateExtraFields = {
  formIndex?: number
  providerType?: ProviderType
}

export type LocalFormValues = DeepPartialSkipArrayKey<FormValues>

const saveToStorage = (value: object) => {
  try {
    sessionStorage.setItem(KEY_INSURANCE_FORM_STATE, JSON.stringify(value))
  } catch (e) {
    logger.error(e)
  }
}

export const setLocalFormState = (formFields: LocalFormValues, extraFields?: FormStateExtraFields) => {
  const localState = {
    formFields,
    formIndex: extraFields?.formIndex,
    providerType: extraFields?.providerType,
  }

  saveToStorage(localState)
}

export const getLocalFormState = (): FormState | null => {
  try {
    const formState = sessionStorage.getItem(KEY_INSURANCE_FORM_STATE)
    if (formState) {
      const parsedFormState: FormState = JSON.parse(formState)
      return parsedFormState
    }
    return null
  } catch (e) {
    logger.error(e)
    return null
  }
}

type ClearOptions = {
  formFieldsOnly?: boolean
}

export const clearLocalFormState = (options?: ClearOptions) => {
  // clear only form fields
  if (options?.formFieldsOnly) {
    const formState = getLocalFormState()
    const rest: Partial<FormState> = { ...formState }
    delete rest.formFields
    if (rest && Object.keys(rest).length) {
      saveToStorage(rest)
      return
    }
  }

  sessionStorage.removeItem(KEY_INSURANCE_FORM_STATE)
}
